/**
 * AP analytics publisher — the single dispatch path for the theme's `ap_*`
 * custom events (docs/analytics/analytics-architecture.md §3).
 *
 * Every call site routes through `publish()`; never call
 * `Shopify.analytics.publish` or `window.dataLayer.push` directly.
 *
 * `Shopify.analytics.publish` is the canonical dispatch: it is the only one
 * that reaches Shopify's Web Pixels sandbox (the sandbox cannot see the main
 * frame's `window.dataLayer`). The dataLayer push is a console-inspectable
 * debugging aid only — no destination ingests it (the Google channel app's
 * gtag.js reads the array but does not forward plain object pushes to GA4;
 * architecture doc §2 constraint 1).
 */

/**
 * Publishes one `ap_*` custom event to the canonical dispatch path.
 * @param {string} eventName - The analytics event name (`ap_*`, snake_case).
 * @param {Record<string, unknown>} payload - The event payload.
 */
export function publish(eventName, payload) {
  try {
    window.Shopify?.analytics?.publish?.(eventName, payload);
  } catch {
    // Analytics must never break the storefront.
  }

  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });
  } catch {
    // Analytics must never break the storefront.
  }
}
